import { List } from '@mui/material';
import React from 'react';
import { Gray } from 'src/Constants';

interface ChatListProps {
  handleBottom: () => void;
}

export const ChatList: React.FC<ChatListProps> = ({
  children,
  handleBottom,
}) => (
  <div
    style={{
      overflow: 'auto',
      flex: 1,
      height: '100%',
    }}
    onScroll={(e) => {
      const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;
      const bottom = scrollHeight - scrollTop < clientHeight + 200;
      if (bottom) {
        console.log('handling bottom');
        handleBottom();
      }
    }}
  >
    <List
      style={{
        flex: 1,
        paddingTop: 0,
        overflow: 'auto',
        border: '1px solid',
        borderColor: Gray,
        borderBottom: 'none',
        borderLeft: 'none',
        borderTop: 'none',
        paddingInline: 15,
        height: '100%',
      }}
    >
      {children}
    </List>
  </div>
);
